import { useState } from 'react';
var idRunningIndex = 0;
var useGenerateId = function (generatedIdPrefix, id) {
    var generatedId = useState(function () { return "asurion-ui-" + generatedIdPrefix + "-" + idRunningIndex++; })[0];
    return id !== null && id !== void 0 ? id : generatedId;
};
export default useGenerateId;
